module.exports = __webpack_public_path__ + "assets/svg/Icons/32/events-gray-cd918d.svg";